module.exports = __webpack_public_path__ + "media/images/landing_page/failiem_upload_pc-2e4f0024dc65c959d3a9942f5ff73087.png";